/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoSavedInventoryDTO } from './geoSavedInventoryDTO';
import { ReferenceMetricsDTO } from './referenceMetricsDTO';
import { GeoTacticChannelDTO } from './geoTacticChannelDTO';


export interface GeoCampaignListingRequestDTO { 
    /**
     * Measured client identifier
     */
    clientId: number;
    /**
     * Brand identifier within the client
     */
    brandId: number;
    /**
     * Primary conversion type ID to filter campaigns for
     */
    conversionTypeId: number;
    /**
     * Tactic + channel pairs to fetch campaigns for
     */
    tactics: Array<GeoTacticChannelDTO>;
    /**
     * Platform vendor name for campaign filtering
     */
    vendor: string;
    /**
     * Scale-in only: start of the test\'s design-time reference window as Unix timestamp in milliseconds. Ignored unless isScaleIn is true; standard selection always uses the rolling 30-day window.
     */
    referencePeriodStartDate?: number;
    /**
     * Scale-in only: end of the test\'s design-time reference window as Unix timestamp in milliseconds. Ignored unless isScaleIn is true.
     */
    referencePeriodEndDate?: number;
    /**
     * Scale-in only: start of the reference window snapshotted at test creation, as Unix timestamp in milliseconds. Campaigns active only in this window keep snapshot metrics for display but remain selectable.
     */
    snapshotRefStartDate?: number;
    /**
     * Scale-in only: end of the reference window snapshotted at test creation, as Unix timestamp in milliseconds.
     */
    snapshotRefEndDate?: number;
    /**
     * Test start date as Unix timestamp in milliseconds for schedule validation
     */
    studyStartDate?: number;
    /**
     * Test end date as Unix timestamp in milliseconds for schedule validation
     */
    studyEndDate?: number;
    /**
     * Geographic granularity level (e.g. DMA, REGION, CITY, ZIP)
     */
    geoSplitType?: string;
    /**
     * Geo test type for determining campaign selection rules
     */
    testType?: GeoCampaignListingRequestDTO.TestTypeEnum;
    /**
     * Target daily scale cost for scale-type tests
     */
    scaleCost?: number;
    /**
     * Planned test duration in days for spend calculations
     */
    testDurationInDays?: number;
    referenceMetrics?: ReferenceMetricsDTO;
    /**
     * Design-space model simulation ID for linking campaign data to test configuration
     */
    dsMdlSimulationId?: number;
    /**
     * Whether the platform supports automatic campaign synchronization
     */
    isSupportedBySyncTool?: boolean;
    /**
     * Saved inventory (id, name, tactic, channel) for inclusion matching and absent-row synthesis
     */
    userSelectedInventory?: Array<GeoSavedInventoryDTO>;
    /**
     * Cell size as a decimal fraction (e.g. 0.15 for 15%) used for SMNS normalization
     */
    cellSize?: number;
    /**
     * Account types for platform configuration matching (matches platform_identifier in cp_doe_platforms)
     */
    accountTypes?: Array<string>;
    /**
     * When true, return scale-in candidate campaigns using the two-window reference model (rolling last-30-days plus the snapshot captured at creation). Campaigns active only in the snapshot keep snapshot metrics for display and remain selectable; campaigns active in the rolling window use rolling reference metrics.
     */
    isScaleIn?: boolean;
}
export namespace GeoCampaignListingRequestDTO {
    export type TestTypeEnum = 'Holdout' | 'Scale' | 'Contribution';
    export const TestTypeEnum = {
        Holdout: 'Holdout' as TestTypeEnum,
        Scale: 'Scale' as TestTypeEnum,
        Contribution: 'Contribution' as TestTypeEnum
    };
}


